import { render, staticRenderFns } from "./MarketplaceChallanNew.vue?vue&type=template&id=38b86173&scoped=true&"
import script from "./MarketplaceChallanNew.vue?vue&type=script&lang=js&"
export * from "./MarketplaceChallanNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b86173",
  null
  
)

export default component.exports